export interface PeriodOption {
    value: string;
    labelKey: string;
    requiresPaid?: boolean;
}

export const PERIOD_OPTIONS: PeriodOption[] = [
    { value: 'TODAY', labelKey: 'periodOptions.TODAY' },
    { value: 'YESTERDAY', labelKey: 'periodOptions.YESTERDAY' },
    { value: 'THIS_WEEK', labelKey: 'periodOptions.THIS_WEEK' },
    { value: 'LAST_WEEK', labelKey: 'periodOptions.LAST_WEEK' },
    { value: 'THIS_MONTH', labelKey: 'periodOptions.THIS_MONTH' },
    { value: 'LAST_MONTH', labelKey: 'periodOptions.LAST_MONTH' },
    { value: 'PAST_7_DAYS', labelKey: 'periodOptions.PAST_7_DAYS' },
    { value: 'PAST_14_DAYS', labelKey: 'periodOptions.PAST_14_DAYS' },
    { value: 'PAST_30_DAYS', labelKey: 'periodOptions.PAST_30_DAYS' },
    { value: 'PAST_3_MONTHS', labelKey: 'periodOptions.PAST_3_MONTHS', requiresPaid: true },
    { value: 'PAST_6_MONTHS', labelKey: 'periodOptions.PAST_6_MONTHS', requiresPaid: true },
    { value: 'PAST_12_MONTHS', labelKey: 'periodOptions.PAST_12_MONTHS', requiresPaid: true },
    { value: 'THIS_YEAR', labelKey: 'periodOptions.THIS_YEAR', requiresPaid: true },
    { value: 'LAST_YEAR', labelKey: 'periodOptions.LAST_YEAR', requiresPaid: true },
];

export const DEFAULT_SIMPLE_ANALYTICS_COLOR = '#2563EB';

export const getPeriodOptions = (isPaidPlan: boolean): PeriodOption[] =>
    PERIOD_OPTIONS.filter((option) => !option.requiresPaid || isPaidPlan);

export const getPeriodDefinition = (value?: string): PeriodOption | undefined => {
    if (!value) return undefined;
    return PERIOD_OPTIONS.find((option) => option.value === value);
};
